__turbopack_context__.v({
  "animationContainer": "CarMatchStartPage-module-scss-module__KG4Tja__animationContainer",
  "animationPlaceholder": "CarMatchStartPage-module-scss-module__KG4Tja__animationPlaceholder",
  "animationPlaceholderHidden": "CarMatchStartPage-module-scss-module__KG4Tja__animationPlaceholderHidden",
  "contentContainer": "CarMatchStartPage-module-scss-module__KG4Tja__contentContainer",
  "cta": "CarMatchStartPage-module-scss-module__KG4Tja__cta",
  "ctaContainer": "CarMatchStartPage-module-scss-module__KG4Tja__ctaContainer",
  "root": "CarMatchStartPage-module-scss-module__KG4Tja__root",
});
